<pmis3-ui-page-template [Title]="'Visit'"
						[screenSize]="'xs'"
						[titleClass]="'noa-template__title'"
						class="noa-template {{!displayNOAList()? 'noa-template__details' : ''}} ">
	@if(displayNOAList()) {
	<div header>
		<div class="row align-items-baseline no-gutters">
			<div class="col-auto flex-basis-200px">
				<kendo-daterange>
					<kendo-floatinglabel [text]="'From'">
						<kendo-dateinput kendoDateRangeStartInput
										 [fillMode]="'outline'"
										 [(value)]="fromDate"
										 [autoSwitchParts]="false"
										 (valueChange)="onFromDateChange($event)"
										 class="w-100"
										 [format]="dateFormat"></kendo-dateinput>
					</kendo-floatinglabel>
					<kendo-floatinglabel [text]="'To'">
						<kendo-dateinput kendoDateRangeEndInput
										 [fillMode]="'outline'"
										 [(value)]="toDate"
										 [autoSwitchParts]="false"
										 (valueChange)="onToDateChange($event)"
										 class="w-100"
										 [format]="dateFormat"></kendo-dateinput>
					</kendo-floatinglabel>
				</kendo-daterange>

				<!-- <kendo-floatinglabel [text]="'From'"
												class="mr-2">
								<kendo-datepicker [(value)]="fromDate"
												[fillMode]="'outline'">
								</kendo-datepicker>
							</kendo-floatinglabel>
							<kendo-floatinglabel [text]="'To'">
								<kendo-datepicker [(value)]="toDate"
												[fillMode]="'outline'">
								</kendo-datepicker>
							</kendo-floatinglabel> -->
			</div>
			<div class="col-auto flex-basis-200px">
				<kendo-textbox [(ngModel)]="query"
							   [fillMode]="'outline'"
							   [placeholder]="'Search...'"
							   (valueChange)="onQueryChange($event)">
					<!-- <ng-template kendoTextBoxSuffixTemplate>
							<button kendoButton
									[fillMode]="'clear'"
									[themeColor]="'primary'"
									[icon]="'search'"
									icon="search"
									(click)="onSearch()"></button>
						</ng-template> -->
				</kendo-textbox>
			</div>

			<div class="col-auto flex-basis-200px">
				<!-- <kendo-combobox [data]="statuses()"
									[value]="selectedStatusFilter()"
									(valueChange)="onSelectedStatusChange($event)"
									[valuePrimitive]="false"
									[valueField]="'id'"
                                    [textField]="'name'"
									[clearButton]="false"
									[placeholder]="'Status'"
									[virtual]="true"
									[popupSettings]="{ width: 'auto'}"
									[fillMode]="'outline'">
					</kendo-combobox> -->
				<kendo-multiselect [data]="statusDropdown()"
								   [(value)]="selectedStatusFilters"
								   [valuePrimitive]="true"
								   [textField]="'name'"
								   [valueField]="'id'"
								   (valueChange)="onSelectedStatusChange($event)"
								   [fillMode]="'outline'"
								   [popupSettings]="{ width: 'auto'}"
								   [placeholder]="'Status'">
				</kendo-multiselect>
			</div>
			<button kendoButton
					[fillMode]="'clear'"
					[themeColor]="'primary'"
					[icon]="'search'"
					icon="search"
					(click)="onSearch()"
					class="align-self-end">
			</button>


			<!-- <div class="col-auto">
					<kendo-radiobutton #current
									value="current"
									[(ngModel)]="currentOrHistory"></kendo-radiobutton>
					<kendo-label class="k-radio-label"
								[for]="current"
								text="Current"></kendo-label>
				</div>
				<div class="col-auto">
					<kendo-radiobutton #history
									value="history"
									[(ngModel)]="currentOrHistory"></kendo-radiobutton>
					<kendo-label class="k-radio-label"
								[for]="history"
								text="History"></kendo-label>
				</div> -->
			<div class="col-auto ml-auto">
				<button kendoButton
						(click)="onNewNOA()"
						[icon]="'plus-circle'"
						[fillMode]="'solid'"
						[themeColor]="'primary'"
						class="new-noa-button">
					<span class="text-capitalize">New Visit</span>
				</button>
			</div>
		</div>
	</div>
	}
	<div body>
		@if (displayNOAList()) {
		@for (vesselVisit of vesselVisits(); track $index) {
		<pmis3-vessel-visit-grid-item [vesselVisit]="vesselVisit"
									  (selectVesselVisit)="onVesselVisitSelected(vesselVisit.id)">
		</pmis3-vessel-visit-grid-item>
		}
		} @else {

		<pmis3-vessel-visit-detail (back)="onBackClicked()"
								   (submitNOA)="onSubmitNOA($event)"
								   (saveNOA)="onSaveNOA($event)"
								   [collapsedVesselAndNOA]="editExistingVesselVisit()"
								   [seaports]="seaports()"></pmis3-vessel-visit-detail>
		}
	</div>
</pmis3-ui-page-template>